'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisibleSuffixCount = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CloseThin = require('./../Icons/dist/components/CloseThin');

var _CloseThin2 = _interopRequireDefault(_CloseThin);

var _ArrowDownThin = require('./../Icons/dist/components/ArrowDownThin');

var _ArrowDownThin2 = _interopRequireDefault(_ArrowDownThin);

var _Search = require('./../Icons/dist/components/Search4');

var _Search2 = _interopRequireDefault(_Search);

var _ThemedInputErrorSuffix = require('./ThemedInputErrorSuffix');

var _ThemedInputErrorSuffix2 = _interopRequireDefault(_ThemedInputErrorSuffix);

var _ThemedInputHelpSuffix = require('./ThemedInputHelpSuffix');

var _ThemedInputHelpSuffix2 = _interopRequireDefault(_ThemedInputHelpSuffix);

var _Input = require('./Input.scss');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFixVisible = function isFixVisible(fix) {
  return fix.isVisible;
};

var suffixRules = {
  inputErrorSuffix: function inputErrorSuffix(_ref) {
    var error = _ref.error,
        disabled = _ref.disabled;
    return error && !disabled;
  },
  inputHelpSuffix: function inputHelpSuffix(_ref2) {
    var help = _ref2.help,
        disabled = _ref2.disabled;
    return help && !disabled;
  },
  magnifyingGlass: function magnifyingGlass(_ref3) {
    var _magnifyingGlass = _ref3.magnifyingGlass,
        isClearButtonVisible = _ref3.isClearButtonVisible,
        error = _ref3.error;
    return _magnifyingGlass && !isClearButtonVisible && !error;
  },
  clearButton: function clearButton(_ref4) {
    var isClearButtonVisible = _ref4.isClearButtonVisible;
    return isClearButtonVisible;
  },
  menuArrow: function menuArrow(_ref5) {
    var _menuArrow = _ref5.menuArrow,
        isClearButtonVisible = _ref5.isClearButtonVisible,
        error = _ref5.error,
        magnifyingGlass = _ref5.magnifyingGlass;
    return _menuArrow && !isClearButtonVisible && !error && !magnifyingGlass;
  },
  unitSeparator: function unitSeparator(_ref6) {
    var unit = _ref6.unit;
    return !!unit;
  },
  unit: function unit(_ref7) {
    var _unit = _ref7.unit;
    return !!_unit;
  },
  customSuffix: function customSuffix(_ref8) {
    var suffix = _ref8.suffix;
    return !!suffix;
  }
};

var getVisibleSuffixCount = function getVisibleSuffixCount(args) {
  return Object.keys(suffixRules).map(function (key) {
    return suffixRules[key];
  }).map(function (fn) {
    return fn(args);
  }).filter(function (x) {
    return x;
  }).length;
};

var InputSuffix = function InputSuffix(_ref9) {
  var theme = _ref9.theme,
      errorMessage = _ref9.errorMessage,
      error = _ref9.error,
      disabled = _ref9.disabled,
      help = _ref9.help,
      helpMessage = _ref9.helpMessage,
      onIconClicked = _ref9.onIconClicked,
      magnifyingGlass = _ref9.magnifyingGlass,
      isClearButtonVisible = _ref9.isClearButtonVisible,
      onClear = _ref9.onClear,
      menuArrow = _ref9.menuArrow,
      unit = _ref9.unit,
      suffix = _ref9.suffix,
      focused = _ref9.focused,
      tooltipPlacement = _ref9.tooltipPlacement,
      onTooltipShow = _ref9.onTooltipShow;


  var suffixes = [{
    component: function component() {
      return _react2.default.createElement(_ThemedInputErrorSuffix2.default, { theme: theme, focused: focused, errorMessage: errorMessage, tooltipPlacement: tooltipPlacement, onTooltipShow: onTooltipShow });
    },
    isVisible: suffixRules.inputErrorSuffix({ error: error, disabled: disabled })
  }, {
    component: function component() {
      return _react2.default.createElement(_ThemedInputHelpSuffix2.default, { theme: theme, help: help, helpMessage: helpMessage, tooltipPlacement: tooltipPlacement, onTooltipShow: onTooltipShow });
    },
    isVisible: suffixRules.inputHelpSuffix({ help: help, disabled: disabled })
  }, {
    component: function component() {
      return _react2.default.createElement(
        'div',
        { className: _Input2.default.magnifyingGlass, disabled: disabled, onClick: onIconClicked },
        _react2.default.createElement(_Search2.default, { size: '18px' })
      );
    },
    isVisible: suffixRules.magnifyingGlass({ magnifyingGlass: magnifyingGlass, isClearButtonVisible: isClearButtonVisible, error: error })
  }, {
    component: function component() {
      return _react2.default.createElement(
        'div',
        { onClick: onClear, className: _Input2.default.clearButton, 'data-hook': 'input-clear-button' },
        _react2.default.createElement(_CloseThin2.default, { size: '8px' })
      );
    },
    isVisible: suffixRules.clearButton({ isClearButtonVisible: isClearButtonVisible })
  }, {
    component: function component() {
      return _react2.default.createElement('div', { className: _Input2.default.unitSeparator });
    },
    isVisible: suffixRules.unitSeparator({ unit: unit })
  }, {
    component: function component() {
      return _react2.default.createElement(
        'div',
        { className: _Input2.default.unit, onClick: onIconClicked },
        unit
      );
    },
    isVisible: suffixRules.unit({ unit: unit })
  }, {
    component: function component() {
      return suffix;
    },
    isVisible: suffixRules.customSuffix({ suffix: suffix })
  }, {
    component: function component() {
      return _react2.default.createElement(
        'div',
        { className: _Input2.default.menuArrow, disabled: disabled, onClick: onIconClicked },
        _react2.default.createElement(_ArrowDownThin2.default, { size: '0.6em' })
      );
    },
    isVisible: suffixRules.menuArrow({ menuArrow: menuArrow, isClearButtonVisible: isClearButtonVisible, error: error, magnifyingGlass: magnifyingGlass })
  }].filter(isFixVisible);

  return _react2.default.createElement(
    'div',
    { className: _Input2.default.suffixes },
    suffixes.map(function (s, i) {
      return _react2.default.createElement(
        'div',
        { key: i, className: _Input2.default.suffix },
        s.component()
      );
    })
  );
};

InputSuffix.propTypes = {
  suffixes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    component: _propTypes2.default.func.isRequired,
    isVisible: _propTypes2.default.bool.isRequired
  })),
  theme: _propTypes2.default.oneOf(['normal', 'tags', 'paneltitle', 'material', 'amaterial', 'flat', 'flatdark']),
  errorMessage: _propTypes2.default.node.isRequired,
  error: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  help: _propTypes2.default.bool,
  helpMessage: _propTypes2.default.node,
  onIconClicked: _propTypes2.default.func,
  magnifyingGlass: _propTypes2.default.bool,
  isClearButtonVisible: _propTypes2.default.bool,
  onClear: _propTypes2.default.func,
  menuArrow: _propTypes2.default.bool,
  unit: _propTypes2.default.string,
  suffix: _propTypes2.default.node,
  focused: _propTypes2.default.bool,
  tooltipPlacement: _propTypes2.default.string,
  onTooltipShow: _propTypes2.default.func
};

exports.default = InputSuffix;
exports.getVisibleSuffixCount = getVisibleSuffixCount;